import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { LoginSuccess } from '@src/types';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { ConfigOutlinedIcon } from '../SvgIcons';

interface AdminActionProps {
  displayIconText?: boolean;
  user: LoginSuccess;
}

const AdminAction: React.FC<AdminActionProps> = ({ displayIconText, user }) => {
  const history = useHistory();
  const { spacing, textIcon, styleIcon } = useStyles();
  return (
    <ButtonBase
      onClick={() => {
        if (!user?.agent) history.push('/admin/audit');
        else history.push('/admin/contact');
      }}
      className={spacing}
    >
      <Box className={styleIcon}>{ConfigOutlinedIcon}</Box>
      <Box className={textIcon}>
        {displayIconText && <FormattedMessage id="HeaderMenu.Admin" />}
      </Box>
    </ButtonBase>
  );
};

export default AdminAction;

const useStyles = makeStyles(theme => ({
  spacing: { display: 'flex', gap: '8px', alignItems: 'center' },
  textIcon: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  styleIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.secondary
        : 'rgb(63, 63, 70)',
    display: 'flex',
    justifyContent: 'center',
    width: 24,
  },
}));
